/** Política de senha — espelho de `backend/src/common/password-policy.ts`. Manter as duas iguais. */

export const PASSWORD_MIN_LENGTH = 8

export const PASSWORD_COMPLEXITY_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d\s])/

export const PASSWORD_RULES_HINT = `Mín. ${PASSWORD_MIN_LENGTH} caracteres com 1 minúscula, 1 maiúscula, 1 número e 1 caractere especial (ex.: @ # $ ! -)`

/** Senha nova + confirmação: o primeiro problema (coincidência, tamanho, complexidade) ou null. */
export function newPasswordError(password: string, confirmation: string): string | null {
  if (password !== confirmation) return 'As senhas não coincidem'
  if (password.length < PASSWORD_MIN_LENGTH) return `A senha deve ter pelo menos ${PASSWORD_MIN_LENGTH} caracteres`
  if (!PASSWORD_COMPLEXITY_REGEX.test(password)) return PASSWORD_RULES_HINT
  return null
}
